module.exports = __webpack_public_path__ + "img/geren2.db184799.png";